var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: { visible: _vm.visible, direction: "rtl", size: "1100px" },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("search-page", {
            ref: "searchPage",
            attrs: {
              "column-count": 3,
              immediate: false,
              "form-data": _vm.formData,
              columns: _vm.columns,
              request: _vm.getList,
            },
            scopedSlots: _vm._u([
              {
                key: "table-user",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "acea-row row-middle" },
                      [
                        _c("el-image", {
                          staticClass: "mr8",
                          attrs: {
                            src: row.userAvatar,
                            "preview-src-list": [row.userAvatar],
                          },
                        }),
                        _c("div", [
                          _c("div", [_vm._v(_vm._s(row.userName))]),
                          _c("div", { staticClass: "ivu-text-left" }, [
                            _vm._v("ID：" + _vm._s(row.userId)),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "table-append",
                fn: function () {
                  return [
                    _c("el-table-column", {
                      attrs: {
                        fixed: "right",
                        label: "操作",
                        align: "center",
                        "min-width": "220",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDetail(row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "任务明细",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-bottom": "20px" },
              attrs: {
                data: _vm.detailList,
                size: "small",
                "highlight-current-row": true,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "taskTitle",
                  label: "任务名称",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "completeCount",
                  label: "完成次数",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "lastCompleteTime",
                  label: "完成时间",
                  "min-width": "160",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }